<template>
  <div>
    <div class="box">
      <el-checkbox style="float: right;margin: 8px;" @change="checkedChange" v-model="checked">全选</el-checkbox>
    </div>
    <div style="margin: 8px;float: right;width: 98%">
      <el-checkbox v-model="checked">全选1</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props :{
    value : {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    groupValue: {
      type: String,
      default: undefined,
    },
    dataValue: {
      type: String,
      default: 'item',
    },
    autoSelect:{
      type:Boolean,
      default:false
    },
    clearKey: {
      type: String,
      default: undefined
    }
  },
  data(){
    return {
      dataInfo: [],
      checked: false,
    }
  },
  watch : {
    data(val){
      this.dataInit(val)
    },
    value(val){
      if (this.dataInfo && this.dataInfo.length > 0) {
        if (this.clearKey) {
          this.checked = this.dataInfo.every(itemA => val.some(itemB => itemA[this.clearKey] === itemB[this.clearKey]));
        } else {
          this.checked = this.dataInfo.length === val.length
        }
      } else if (this.data.length > 0) {
        if (this.clearKey) {
          this.checked = this.data.every(itemA => val.some(itemB => itemA[this.clearKey] === itemB[this.clearKey]));
        } else {
          this.checked = this.data.length === val.length
        }
      }
    }
  },
  created() {
    this.dataInit(this.data)
  },
  methods : {
    checkedChange(){
      if (this.checked)
        this.selectAll()
      else
        this.cancel()
    },
    selectAll(){
      if (this.clearKey) {
        let value = this.value
        if (this.dataInfo && this.dataInfo.length > 0)
          value = value.concat(this.dataInfo.slice())
        else if (this.data.length > 0)
          value = value.concat(this.data.slice())
        this.$emit('input',value)
      } else {
        let value = []
        if (this.dataValue !== 'item'){
          value = this.dataInfo.map(d => d[this.dataValue]).slice()
        } else {
          if (this.dataInfo && this.dataInfo.length > 0)
            value = this.dataInfo.slice()
          else if (this.data.length > 0)
            value = this.data.slice()
        }
        this.$emit('input',value)
      }
      this.$emit('change')
    },
    cancel(){
      if (this.clearKey) {
        let value = this.value.filter(itemA => !this.dataInfo.some(itemB => itemA[this.clearKey] === itemB[this.clearKey]))
        this.$emit('input',value)
      } else {
        this.$emit('input',[])
      }
      this.$emit('change')
    },
    dataInit(val) {
      this.dataInfo = []
      if (this.groupValue){
        let dataInfo = []
        val.forEach(d => {
          let group = d[this.groupValue]
          dataInfo = dataInfo.concat(group)
        })
        this.dataInfo = dataInfo
      }else{
        this.dataInfo = val
      }
      this.checked = this.dataInfo.length == this.value.length

      if(this.dataInfo.length == 1 && this.autoSelect){
        this.checked = true;
        this.selectAll();
      }
    }
  }
}
</script>

<style scoped>
.box {
  position: absolute;
  z-index: 2000;
  width: 98%;
  top: -1px;
  background: white;
  height: 34px;
  vertical-align: middle;
}
</style>
